import { useEffect, useState } from "react";

export const useGetCurrentUserAgent = () => {
  const [userAgent, setUserAgent] = useState("");
  useEffect(() => {
    if (userAgent) return;
    setUserAgent(navigator?.userAgent);
  }, []);

  return { userAgent };
};
